import { isAndroidCapacitor } from './platformUtils';

export const FIXED_LAYOUT_AD_CONTAINER_IDS = [
    'ad-container-right-banner',
    'mobile-top-ad',
    'mobile-bottom-ad',
];

/** Re-push AdSense slots after route / step changes (production web only). */
export function reloadFixedLayoutAds() {
    if (isAndroidCapacitor()) return;

    FIXED_LAYOUT_AD_CONTAINER_IDS.forEach((id) => {
        const adContainer = document.getElementById(id);
        if (adContainer?.querySelector('.adsbygoogle')) {
            try {
                if (typeof window !== 'undefined') {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                }
            } catch (e) {
                console.error(`AdSense reload error for ${id}:`, e);
            }
        }
    });
}
